const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:8080/api/';
//const URL_API = '//127.0.0.1:8080/api/';

const constants = {
    title: 'Kelly detox',
    URL_API,
};

export default constants;
